// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"b93c3e59","488":"e75445ad"}[chunkId] + ".chunk.js";
};